import { BaseTabBarItem, BaseTabBarItemProps } from './BaseTabBarItem';

export type TabBarItemProps<K extends string | number> = Omit<BaseTabBarItemProps<K>, 'removeIcon'>;

export function TabBarItem<K extends string | number>({
  itemKey,
  label,
  icon,
  badge,
  metadata,
  severity
}: TabBarItemProps<K>) {
  return (
    <BaseTabBarItem
      itemKey={itemKey}
      label={label}
      icon={icon}
      badge={badge}
      metadata={metadata}
      severity={severity}
    />
  );
}
